import { type TranslationTree } from '@/i18n/types';

export const messages = {
  back: 'Voltar para os eventos',
  backLabel: 'Eventos',
  delete: 'Apagar',
  cancel: 'Cancelar evento',
  edit: 'Editar',
  editAndResubmit: 'Editar e reenviar',
  submit: 'Enviar para análise',
} satisfies TranslationTree;
